var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _polygon, _polygon2, _polygon3, _polygon4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMinos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#262221;}.cls-2{fill:#001d19;}.cls-3{fill:url(#linear-gradient);}.cls-4{fill:url(#linear-gradient-2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 429.9,
    y1: 456.31,
    x2: 283.14,
    y2: 456.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#93f9b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1d976c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 805.41,
    y1: 456.31,
    x2: 1036.15,
    y2: 456.31,
    gradientTransform: "matrix(-1, 0, 0, 1, 1124.81, 0)",
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M504.82,486.53V396.66H520.6l29.91,58.68,29.66-58.68h15.91v89.87H581.57V424.28l-26.09,50.54H545.29l-26-50.54v62.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M617.08,486.53V396.66h14.77v89.87Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M653,486.53V396.66h13.75l43.53,63.52V396.66h14.51v89.87H710.89L667.48,423v63.52Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M741.44,441.59c0-27.36,20.36-46.33,46.71-46.33s46.72,19,46.72,46.33-20.37,46.34-46.72,46.34S741.44,469,741.44,441.59Zm78.28,0c0-19.34-13.62-32.84-31.57-32.84s-31.69,13.5-31.69,32.84,13.74,32.85,31.69,32.85S819.72,460.94,819.72,441.59Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M844.92,469.34l12-7.25c3.57,8.4,11.08,12.6,21.39,12.6s16.29-4.2,16.29-13.11c0-8.4-5.35-10.44-18.33-13.11-15.27-3.31-28.64-8.28-28.64-26.73,0-17.06,12.6-26.48,29.28-26.48,14.51,0,25.46,6.75,30.16,17.31l-12.22,7.13c-3.69-7.76-9.92-11.2-17.56-11.2-8.91,0-14.64,4.58-14.64,13,0,9.8,6.24,11.46,19.48,13.88,15.4,2.92,27.49,8.78,27.49,25.84,0,17.44-11.71,26.73-30.93,26.73C861.85,487.93,849.5,481.05,844.92,469.34Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M504.45,553.28V517.15h3.74l14,25.79,13.92-25.79h3.73v36.13h-3.63v-29L523.44,547.7h-2.61l-12.75-23.44v29Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M603.48,553.28,600,543.86H583.11l-3.48,9.42h-3.84l13.72-36.13h4.09l13.72,36.13Zm-11.93-32.09-7.16,19.29h14.28Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M669.55,553.28H665.1l-11.42-15.2h-6.75v15.2h-3.64V517.15h11.37c8.34,0,11.41,4.19,11.41,10.18s-3.07,9.37-8.39,10.19Zm-22.62-32.81v14.28h6.91c5.22,0,8.54-1.79,8.54-7.42,0-5.17-2.71-6.86-8.39-6.86Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M732.45,553.28h-4.87l-18-18.27v18.27H706V517.15h3.63v16.94l16.53-16.94h4.76L714,534.5Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M768.89,553.28V517.15h21v3.32H772.52v13h15.1v3.33h-15.1V550h17.86v3.33Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M836.7,553.28V520.47H825.18v-3.32h26.61v3.32H840.28v32.81Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M886,545.86l3.12-1.59c1.44,4.15,5.17,6.19,10,6.19,5.38,0,8.14-2.5,8.14-6.85s-3-5.63-8.85-6.86-11.21-2.82-11.21-10c0-6.35,4.4-10.19,11.1-10.19,5.38,0,9.57,2.56,11.52,6.91l-3.17,1.59a8.6,8.6,0,0,0-8.29-5.12c-4.66,0-7.42,2.51-7.42,6.71,0,5,3.48,5.73,8.75,6.75,6.44,1.28,11.31,3.43,11.31,10.19,0,6.5-4.46,10.23-11.83,10.23C892.79,553.84,887.77,551.08,886,545.86Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M504.45,620.87V584.73h3.63v32.81h17.66v3.33Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M568.83,620.87V584.73h3.58v36.14Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M618.63,620.87V584.73h3.73l14,25.8,13.93-25.8H654v36.14h-3.63v-29l-12.74,23.44H635l-12.74-23.44v29Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M700.15,620.87V584.73h3.59v36.14Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M758.5,620.87V588.06H747v-3.33h26.61v3.33H762.08v32.81Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M816.43,620.87V584.73h21v3.33H820.06v13.05h15.1v3.33h-15.1v13.1h17.86v3.33Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M881.73,620.87V584.73h11.06c11.87,0,18.17,7.68,18.17,18.07s-6.09,18.07-17.92,18.07Zm3.64-3.33h7.73c9.67,0,14.12-6.29,14.12-14.74s-4.71-14.74-14.38-14.74h-7.47Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "88.66 620.87 133.53 620.87 285.35 469.06 285.35 425.87 88.66 620.87"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "258.07 574.14 255.82 620.87 407.63 469.06 407.63 425.87 258.07 574.14"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "377.84 620.87 441.69 557.01 441.69 291.76 285.76 447.69 285.76 546.95 377.84 455.32 377.84 620.87"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "255.55 620.87 319.4 557.01 319.4 291.76 88.66 521.6 88.66 620.87 255.55 455.32 255.55 620.87"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinos);
export default __webpack_public_path__ + "static/media/minos.0d08b3c0565c3df0aed95b2536a1bc6f.svg";
export { ForwardRef as ReactComponent };